import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ZnsCampaignTargetAudience, ZnsCampaignType } from "modules/outbound-message/types/znsCampaign";
import { ZnsTemplateTag } from "modules/outbound-message/types/znsTemplate";
import { IHttpError } from "types/http";

export interface INotificationPayload {
  Relation?: "WithoutZnsCampaign" | "WithZnsCampaign";
  Status?: "Pending" | "Sent" | "Invalid" | "Error";
  ZnsCampaignId?: string;
  ZnsTemplateTag?: "TRANSACTION" | "CUSTOMER_CARE" | "PROMOTION";
  ZnsCampaignType?: "MANUAL" | "AUTO";
  CreatedDateFrom?: string;
  CreatedDateTo?: string;
  ModifiedDateFrom?: string;
  ModifiedDateTo?: string;
  SendDateFrom?: string;
  SendDateTo?: string;
  SortBy?:
    | "ModifiedDate"
    | "CreatedDate"
    | "ZnsCampaignName"
    | "ZnsTemplateName"
    | "ZnsTemplateTag"
    | "Status";
  PageNumber?: number;
  PageSize?: number;
  SearchTerm?: string;
  SortDirection?: "ASC" | "DESC";
}

export interface IMessage {
  notificationMessageId?: string;
  customerId?: string;
  customerName?: string;
  errorCode?: string;
  issuedRewardId?: string;
  messageContent?: string;
  code?: string;
  rewardCode?: string;
  prizeName?: string;
  prizeType?: number;
  template?: string;
  phoneNumber?: string;
  lastSendError?: string;
  sendAttemptCount?: number;
  lastSendAttemptDate?: string;
  sendDate?: string;
  status?: string;
  createdDate?: string;
  modifiedDate?: string;
  znsCampaignId?: string;
  znsCampaignName?: string;
  znsCampaignType?: ZnsCampaignType;
  znsTemplateName?: string;
  znsTemplateTag?: ZnsTemplateTag;
  znsConfigurationId?: string;
  znsCampaignTargetAudience?: ZnsCampaignTargetAudience;
}

export interface IMessages {
  results: IMessage[];
  totalCount: number;
  totalSuccess: number;
  totalFailed: number;
  totalSent: number;
}

export interface IState {
  loading?: boolean;
  data?: IMessages;
  error?: IHttpError;
}

const initialState: IState = {
  loading: false,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    loadZNSNotification: (
      state,
      _action: PayloadAction<INotificationPayload>
    ) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    },
    loadZNSNotificationSuccess: (state, action: PayloadAction<IMessages>) => {
      state.loading = false;
      state.data = action.payload;
    },
    loadZNSNotificationFailed: (state, action: PayloadAction<IHttpError>) => {
      state.loading = false;
      state.error = action.payload;
    },
    exportZNSNotification: (_state, _action: PayloadAction<INotificationPayload>) => {},
  },
});

export const {
  loadZNSNotification,
  loadZNSNotificationSuccess,
  loadZNSNotificationFailed,
  exportZNSNotification,
} = notificationSlice.actions;

export const selectZNSNotification = (state: RootState) =>
  state.notification?.data;
export const selectTotalCount = (state: RootState) =>
  state.notification?.data?.totalCount;
export const selectPageCount = (state: RootState) =>
  state.notification?.data?.results?.length;

export default notificationSlice.reducer;
